import React, { useEffect, useState } from "react";
import '../../universal.css';
import { orderedAirports } from '../../data/config';
import { URL_START } from '../../data/config';

const ATS = () => {
  const [atcData, setAtcData] = useState([]);
  const [isVisible, setIsVisible] = useState(true); 

  // Fetch ATS data function
  const fetchATS = async () => {
    console.log("Updating ATS table");
    try {
      const response = await fetch(`${URL_START}/api/atc`);
      const data = await response.json();
      setAtcData(data);
    } catch (error) {
      console.error("Error fetching ATS data:", error);
    }
  };

  useEffect(() => {
    let interval;

    if (isVisible) {
      fetchATS(); // Initial fetch
      interval = setInterval(fetchATS, 4 * 60 * 1000); // Refresh every 4 minutes
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isVisible]);

  // Group ATS positions by airport (ad)
  const groupedATS = atcData.reduce((acc, atc) => {
    if (!acc[atc.ad]) {
      acc[atc.ad] = [];
    }
    acc[atc.ad].push(atc);
    return acc;
  }, {});

  // Sort by orderedAirports, with EFIN first
  const sortedAirports = ["EFIN", ...orderedAirports.map(a => a.icao).filter(icao => icao !== "EFIN")];

  return (
    <div className="text-black h-full p-0">
      <div className="overflow-y-auto text-black text-xs monospace-font pb-8 h-full">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-300 text-left">
              <th className="border p-1">CALLSIGN</th>
              <th className="border p-1">FREQ</th>
              <th className="border p-1">CODE</th>
              <th className="border p-1">SERVICE TYPE</th>
              <th className="border p-1">ATCO</th>
              
            </tr>
          </thead>
          <tbody>
            {atcData.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center p-4 bg-gray-200">
                  No ATS-units online
                </td>
              </tr>
            ) : (
              sortedAirports.map(icao => {
                if (!groupedATS[icao]) return null;

                return (
                  <React.Fragment key={icao}>
                    {/* Airport row */}
                    <tr className="bg-gray-400 text-white">
                      <td colSpan="6" className="p-1 font-bold">
                        {icao} - {orderedAirports.find(a => a.icao === icao)?.name || "Helsinki ACC"}
                      </td>
                    </tr>
                    {/* ATC rows */}
                    {groupedATS[icao].map((atc, index) => (
                      <tr key={index} className="bg-gray-100 border-b">
                        <td className="border p-1">{atc.callsign}</td>
                        <td className="border p-1">{atc.frequency}</td>
                        <td className="border p-1">{atc.lfunc}</td>
                        <td className="border p-1">{atc.service || ""}</td>
                        <td className="border p-1">{atc.atco}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ATS;
